import { DatePicker, DatePickerProps } from 'antd';
import { ReactComponent as DatePickerIcon } from '@Icons/additional/date-picker.svg';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';

const cellRender: DatePickerProps<Dayjs>['cellRender'] = (current, info) => {
  if (info.type !== 'date') {
    return info.originNode;
  }
  if (typeof current === 'number' || typeof current === 'string') {
    return <div className="ant-picker-cell-inner">{current}</div>;
  }

  const yearMatched = dayjs().year() === current.year();
  const monthMatched = dayjs().month() === current.month();
  const dayOfMonthMatched = dayjs().date() === current.date();

  const isCurrentDay = yearMatched && monthMatched && dayOfMonthMatched;

  return (
    <div
      className={classNames(
        'trojan-picker-cell ant-picker-cell-inner',
        isCurrentDay ? 'trojan-picker-cell-current-day' : null
      )}
    >
      {current.date()}
    </div>
  );
};

const MDatePicker: React.FC<DatePickerProps<string | Dayjs>> = (props) => {
  const { format = 'DD/MM/YYYY', placeholder = 'DD/MM/YYYY' } = props;

  return (
    <DatePicker
      cellRender={cellRender}
      {...props}
      className={classNames('trojan-date-picker', props.className)}
      format={format}
      suffixIcon={<DatePickerIcon />}
      placeholder={placeholder}
    />
  );
};

export default MDatePicker;
